module.exports = __webpack_public_path__ + "static/media/logo.04eaab63.png";